var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEbcRestrictedArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14161_103932)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_14161_103932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5 11H20.5C16.0817 11 12.5 14.5817 12.5 19V59C12.5 63.4183 16.0817 67 20.5 67H59.5C63.9183 67 67.5 63.4183 67.5 59V19C67.5 14.5817 63.9183 11 59.5 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5 12.5H20.5C16.9101 12.5 14 15.4101 14 19V59C14 62.5899 16.9101 65.5 20.5 65.5H59.5C63.0899 65.5 66 62.5899 66 59V19C66 15.4101 63.0899 12.5 59.5 12.5Z",
    stroke: "#FF8027",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 24C37.0333 24 34.1332 24.8797 31.6665 26.528C29.1997 28.1762 27.2771 30.5189 26.1418 33.2597C25.0065 36.0006 24.7094 39.0166 25.2882 41.9264C25.867 44.8361 27.2956 47.5088 29.3934 49.6066C31.4912 51.7044 34.1639 53.133 37.0737 53.7118C39.9834 54.2906 42.9994 53.9935 45.7403 52.8582C48.4811 51.7229 50.8238 49.8003 52.472 47.3336C54.1203 44.8668 55 41.9667 55 39C55 37.0302 54.612 35.0796 53.8582 33.2597C53.1044 31.4399 51.9995 29.7863 50.6066 28.3934C49.2137 27.0005 47.5601 25.8956 45.7403 25.1418C43.9204 24.388 41.9698 24 40 24ZM26.8667 39C26.8565 36.4854 27.5694 34.0209 28.9203 31.9001C30.2713 29.7792 32.2034 28.0914 34.4866 27.0376C36.7697 25.9838 39.3077 25.6086 41.7981 25.9565C44.2885 26.3044 46.6264 27.3609 48.5333 29L30.1 47.6667C28.0002 45.2695 26.8501 42.1868 26.8667 39ZM40 52.1167C36.8438 52.1191 33.7939 50.9761 31.4167 48.9L49.9 30.4167C51.5408 32.3149 52.6019 34.6444 52.9573 37.1281C53.3126 39.6119 52.9472 42.1455 51.9044 44.4276C50.8616 46.7097 49.1854 48.6444 47.0751 50.0016C44.9648 51.3587 42.5091 52.0813 40 52.0833V52.1167Z",
    fill: "#FF8027"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14161_103932",
    x: 0.5,
    y: 0,
    width: 79,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14161_103932"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14161_103932",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_14161_103932",
    x: 0.5,
    y: 0,
    width: 79,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14161_103932"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14161_103932",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_14161_103932"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbcRestrictedArea);
export default __webpack_public_path__ + "static/media/EBC-restricted-area.5df44c96a56ddc51ba9e88dd5538b6e6.svg";
export { ForwardRef as ReactComponent };